import { BarMouseOver } from 'widgets/historicalPercentageChange/components/HistoricalPercentageChangeChart/barMouseOver.ts';
import { HistoricalPercentageChangeDataItem } from 'widgets/historicalPercentageChange/data/historicalPercentageChangeDataItem.ts';
import { useContext, useEffect, useState } from 'react';
import AppContext from 'app/AppContext.tsx';
import classNames from 'classnames';
import {
    FormattedDataItem,
    toFormattedDataItem,
} from 'widgets/historicalPercentageChange/capsule/components/formattedDataItem.ts';

export function HistoricalPercentageChangeCapsuleFrontHeader({
    averageVolume,
    barMouseOver,
    data,
}: {
    averageVolume: number | undefined;
    barMouseOver: BarMouseOver;
    data: HistoricalPercentageChangeDataItem[];
}) {
    const { numberFormat } = useContext(AppContext);

    const [subtitleData, setSubtitleData] = useState<
        FormattedDataItem | undefined
    >(undefined);
    const [defaultItem, setDefaultItem] = useState<
        FormattedDataItem | undefined
    >(undefined);

    const [hovering, setHovering] = useState(false);

    useEffect(() => {
        const defaultItem = toFormattedDataItem(
            averageVolume,
            data[data.length - 1],
            numberFormat
        );
        setDefaultItem(defaultItem);
    }, [averageVolume, data, numberFormat]);

    useEffect(() => {
        barMouseOver.subscribe(
            'HistoricalPercentageChangeWidgetChartLegends',
            (mouseOverState) => {
                setSubtitleData(
                    mouseOverState?.item
                        ? toFormattedDataItem(
                              averageVolume,
                              mouseOverState?.item,
                              numberFormat
                          )
                        : undefined
                );
                setHovering(!!mouseOverState?.item);
            }
        );
    });

    const item = subtitleData ?? defaultItem;

    if (!item) {
        return <></>;
    }

    const { date, price, volume, percent, percentPositive } = item;

    const cssClasses = classNames(
        'HistoricalPercentageChangeCapsuleFrontHeader',
        percentPositive ? 'up' : 'down'
    );
    return (
        <div className={cssClasses}>
            <span className="price">
                {price !== '' && <>{price}</>}
                {price === '' && <>&nbsp;</>}
            </span>
            <div className="sub-title">
                <div className="date">{hovering && date}</div>
                {percent !== '' && <div className="percent">{percent}%</div>}
                <div className="volume">{hovering && volume}</div>
            </div>
        </div>
    );
}
